import React, { useState } from 'react';
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { generateBackground } from '../../components/utils/utils'
import { 
  Segment,
  Container,
  Image,
  List,
  Grid,
  Header,
} from 'semantic-ui-react'
// NPM
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXTwitter } from '@fortawesome/free-brands-svg-icons'
// styles
import * as styles from './footer.module.scss';

const Footer = (props) => {
  const { footer, isMobile } = props;
  const { 
    //contentItemId,
    //contentType,
    //displayText,
    commonPageSection,
    logo,
    socialItems,
    navItems,
    subFooterItems,
  } = footer.contentItems[0];
  //console.debug('footer', footer);

  const [currentYear] = useState(dayjs().year());

  const sectionBackground = generateBackground(commonPageSection.backgroundColor, commonPageSection.backgroundImage);
  //console.debug('footer - sectionBackground', sectionBackground);

  const imageAltText = 'Triton Digital Logo';

  return (
    <>
      <Segment id="footer" basic vertical className={styles.layout_footer} style={{ background: sectionBackground, color: (commonPageSection.textColor ? commonPageSection.textColor : null), }}>
        <Container textAlign='center'>
          <Grid doubling stackable columns={'equal'} className={'footer-content'}>
            <Grid.Row>
              <Grid.Column computer={4} mobile={16} textAlign={'left'} className={'info-column'}>
                {logo ?
                  (logo.gatsbyImageData ?
                    <GatsbyImage image={getImage(logo.gatsbyImageData)} alt={imageAltText} />
                  : logo.imageAbsoluteUrls && logo.imageAbsoluteUrls.length !== 0 ?
                    <Image wrapped className={'logo-image'} size={'medium'} src={logo.imageAbsoluteUrls[0]} alt={imageAltText} />
                  : logo.urls && logo.urls.length !== 0 ?
                    <Image wrapped className={'logo-image'} size={'medium'} src={logo.urls[0]} alt={imageAltText} />
                  :
                    null
                  )
                :
                  null
                }
                {socialItems && socialItems.contentItems.length !== 0 ?
                  <div className={'connect-row'}>
                    <List link horizontal size={'small'}>
                      {socialItems.contentItems.map((socialItem, i) => {
                        if (socialItem.icon.iconName === 'twitter') {
                          return (
                            <List.Item key={i} as={'a'} href={socialItem.link.url} target={'_blank'} rel={'noreferrer'} aria-label={socialItem.icon.iconName+' Social Link'}>
                              <FontAwesomeIcon icon={faXTwitter} />
                            </List.Item>
                          )
                        } else {
                          return (
                            <List.Item key={i} as={'a'} href={socialItem.link.url} target={'_blank'} rel={'noreferrer'} aria-label={socialItem.icon.iconName+' Social Link'}>
                              <List.Icon size={'large'} name={socialItem.icon.iconName} />
                            </List.Item>
                          )
                        }
                      })}
                    </List>
                  </div>
                :
                  null
                }
              </Grid.Column>
              {navItems && navItems.contentItems.length !== 0 ?
                (navItems.contentItems.map((navItem, i) => {
                  return (
                    <Grid.Column key={i} textAlign={'left'}>
                      <Header as='h4' content={navItem.text} />
                      {navItem.navItems && navItem.navItems.contentItems.length !== 0 ?
                        <List link relaxed>
                          {navItem.navItems.contentItems.map((navItemItem, i) => {
                            return (
                              <List.Item key={i} 
                                as={navItemItem.externalLink && navItemItem.externalLink.url !== null ? 'a' : Link}
                                href={navItemItem.externalLink && navItemItem.externalLink.url !== null ? navItemItem.externalLink.url : null}
                                to={navItemItem.internalLink && navItemItem.internalLink.url !== null ? navItemItem.internalLink.url : null}
                                target={navItemItem.externalLink && navItemItem.externalLink.url !== null ? '_blank' : null} 
                                rel={navItemItem.externalLink && navItemItem.externalLink.url !== null ? 'noreferrer' : null}
                              >
                                {navItemItem.text}
                              </List.Item>
                            )
                          })}
                        </List>
                      :
                        null
                      }
                    </Grid.Column>
                  )
                }))
              :
                null
              }
            </Grid.Row>
          </Grid>
          <Grid stackable className={'footer-extra-content'}>
            <Grid.Row>
              <Grid.Column width={3} textAlign={'left'} className={'copyright-column'}>
                <p>&copy; {currentYear} Triton Digital &reg;</p>
              </Grid.Column>
              <Grid.Column width={13} textAlign={'right'} className={'more-info-column'}>
                {subFooterItems && subFooterItems.contentItems.length !== 0 ?
                  <List horizontal={isMobile ? null : true} divided link relaxed size={'small'}>
                    {subFooterItems.contentItems.map((navItem, i) => {
                      return (
                        <List.Item key={i} 
                          as={navItem.externalLink && navItem.externalLink.url !== null ? 'a' : Link}
                          href={navItem.externalLink && navItem.externalLink.url !== null ? navItem.externalLink.url : null}
                          to={navItem.internalLink && navItem.internalLink.url !== null ? navItem.internalLink.url : null}
                          target={navItem.externalLink && navItem.externalLink.url !== null ? '_blank' : null} 
                          rel={navItem.externalLink && navItem.externalLink.url !== null ? 'noreferrer' : null}
                        >
                          {navItem.text}
                        </List.Item>
                      )
                    })}
                    <List.Item as='button' id={'ot-sdk-btn'} className={'ot-sdk-show-settings'}>
                      Do Not Sell My Personal Information
                    </List.Item>
                  </List>
                :
                  null
                }
              </Grid.Column>
            </Grid.Row>
          </Grid>            
        </Container>
      </Segment>
    </>
  )
}

export default Footer
